import { render, staticRenderFns } from "./SumahoOrderHeader.vue?vue&type=template&id=bacb5bde&scoped=true&"
import script from "./SumahoOrderHeader.vue?vue&type=script&lang=js&"
export * from "./SumahoOrderHeader.vue?vue&type=script&lang=js&"
import style0 from "./SumahoOrderHeader.vue?vue&type=style&index=0&id=bacb5bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacb5bde",
  null
  
)

export default component.exports